import { Box, Typography, useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 *
 /**
  * 
/**
 * Loading component with dots.
 *
 * @param {Object} props
 * @param {MUIColor} props.color - Dots and text color.
 * @param {String} props.waitingMessage - Message to show while waiting.
 * @param {Number} props.size - Integer size.
 * @param {String} [props.padding="20px"] - Padding around the component.
 * @returns {JSX.Element} The DataLoadingDots component
 */
const DataLoadingDots = ( { dotSize = 5, spaceBetween = 5, color = 'primary', waitingMessage, padding = "5px" } ) => {

    const { palette } = useTheme()

    return (
        <Box
            sx={{
                padding: padding,
                display: "flex",
                gap: "10px",
                alignItems: "center"
            }}>
            <Box
                className="loading-dots"
                sx={{
                    display: "flex",
                    gap: `${spaceBetween}px`
                }}>
                <Box
                    className="dot"
                    sx={{
                        bgcolor: palette[color]?.main || color,
                        width: `${dotSize}px`,
                        borderRadius: "50%",
                        height: `${dotSize}px`
                    }}></Box>
                <Box
                    className="dot"
                    sx={{
                        bgcolor: palette[color]?.main || color,
                        width: `${dotSize}px`,
                        borderRadius: "50%",
                        height: `${dotSize}px`
                    }}></Box>
                <Box
                    className="dot"
                    sx={{
                        bgcolor: palette[color]?.main || color,
                        width: `${dotSize}px`,
                        borderRadius: "50%",
                        height: `${dotSize}px`
                    }}></Box>
            </Box>
            {waitingMessage && <Typography
                color={color}
                variant='caption'
                sx={{
                    fontSize: "14px",
                    fontWeight: "500"
                }}>{waitingMessage}</Typography>}
        </Box>
    );
}

DataLoadingDots.propTypes = {
    dotSize: PropTypes.number,
    spaceBetween: PropTypes.string,
    color: PropTypes.string,
    padding: PropTypes.string,
    waitingMessage: PropTypes.string,
}

export default DataLoadingDots
